import gql from 'graphql-tag';

const GET_TENANT_PROFILE = gql`
  query getTenantProfile {
    tenantProfile {
      phone
    }
  }
`;

export const getTenantProfile = async client => {
  const { data } = await client.query({ query: GET_TENANT_PROFILE });
  return data;
};

export default getTenantProfile;
